<template>
	<div v-loading="dataLoading">
		<el-form v-if="formData" :model="formData" ref="formData" label-position="top">
			<GoodsBaseInfo v-if="reFresh" :formData.sync="formData" :id="id"></GoodsBaseInfo>
			<GoodsBindInfo v-if="reFresh" :formData.sync="formData" :id="id"></GoodsBindInfo>
			<GoodsSku v-if="reFresh" :formData.sync="formData" @validateField="validateField"
				:validateProperty.sync="validateProperty"></GoodsSku>
			<GoodsPosters v-if="reFresh" :s-list.sync="formData.posters"></GoodsPosters>
			<GoodsDescription :formData.sync="formData" :reFresh="reFresh"></GoodsDescription>
			<el-form-item prop="status">
				<el-checkbox v-model="onlineStatus" :true-label="1" :false-label="0">定时上架</el-checkbox>
				<el-date-picker v-model="formData.onlineTime" type="datetime" placeholder="请输入定时上架时间"
					format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" size="small"
					style="width: 30%; margin-left: 20px;" v-if="onlineStatus == 1"
					:picker-options="pickerOptions"></el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button @click="goBack">返回</el-button>
				<el-button v-if="$utils.have('/shop_good/createOrUpdate')" type="primary" @click="onSubmit"
					:loading="btnLoading">保存</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	import GoodsBaseInfo from './components/goods-baseInfo';
	import GoodsBindInfo from './components/goods-bindInfo';
	import GoodsSku from './components/goods-sku';
	import GoodsDescription from './components/goods-description';
	import GoodsPosters from './components/goods-posters';
	export default {
		props: {
			id: {
				type: [Number, String],
				default: ''
			}
		},

		components: {
			GoodsBaseInfo,
			GoodsBindInfo,
			GoodsSku,
			GoodsDescription,
			GoodsPosters
		},
		data() {
			return {
				pickerOptions: {
					disabledDate: (time) => {
						const now = new Date();
						const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
						return time.getTime() < todayStart.getTime()
					},
				},
				onlineStatus: 0,
				dataLoading: false,
				btnLoading: false,
				redirect: this.$route.query.redirect || '',
				defaultFormData: {
					//基本信息
					poster: '',
					posterOriginal: '',
					name: '',
					categoryId: 1,
					priceFormat: undefined,
					originalPriceFormat: undefined,
					limitBuyNum: 0,
					startDate: '',
					freightFormat: 0,
					freightTemplateId: '',
					freightType: '',
					deliveryType: 1,
					//deliveryUserId:'',
					pickupInstruction: '',
					serviceFee: '',
					serviceTemplateId: [],
					type: 1,
					giftDescription: '',
					bigGiftDescription: '',
					bigGiftSpecial: '',
					shipper: "",
					//图文信息
					templates: [],
					description: '',
					//品类信息
					shopGoodsSku: [],
					properties: [{
						name: '',
						orderIndex: '1',
						value: '',
					}, {
						name: '',
						orderIndex: '2',
						value: '',
					}],
					propertyType: 1, //品类层级
					//绑定信息
					bUser: [],
					balanceType: 2,
					organizeres: [],
					performeres: [],
					sites: [],
					settlements: [],
					settlementsVO: [],
					activities: [],
					isConfirmedStartTime: 1,
					oldPoster: '',
					soldOut: 1,
					whiteListImportPath: '',
					haveWhiteList: 0,
					posters: [],
					canAfter: 1,
					operationalCategory: [],
					hideType: 0,
					deliveryTimeValue: 3,
					onlineTime: ''
				},
				formData: null,
				reFresh: false,
				validateProperty: false,

			}
		},

		created() {
			this.formData = {
				...this.defaultFormData
			};
			if (this.id) {
				this.getDataDetail();
			} else {
				this.reFresh = true;
			}

		},

		methods: {
			//获取详情
			getDataDetail() {
				this.dataLoading = true;
				this.$request({
						url: "/shop_good/detail",
						params: {
							id: parseInt(this.id)
						},
						method: "post",
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1) {
							result.properties.map(item => {
								item.value = item.value ? item.value : ""
							})
							this.formData = {
								...this.defaultFormData,
								...result,
								propertyType: result.properties && result.properties.length > 1 ? 2 : 1,
								// settlementsVO: result.settlements && result.settlements.length > 0 ? result.settlements[0] : null,
								serviceTemplateId: result.serviceTemplateId && result.serviceTemplateId.split(
									',') || [],
								freightType: result.freightFormat ? 1 : 2,
								operationalCategory: result.operationalCategoryList,
								deliveryTimeValue2: result.deliveryTimeType == 2 ? result.deliveryTimeValue : '',
								deliveryTimeValue: result.deliveryTimeType == 1 ? result.deliveryTimeValue : 3
							}
							if (this.formData.onlineTime && this.formData.onlineTime != '') {
								this.onlineStatus = 1
							}
							if (this.formData.bindList && this.formData.bindList.length > 0) {
								this.formData.activities = []
								this.formData.settlementsVO = []
								this.formData.bUser = []
								this.formData.bindList.map(v => {
									if (v.bindType == 6) {
										this.formData.activities.push({
											...v,
											userType: v.bindType
										})
									} else if (v.bindType == 9) {
										this.formData.settlementsVO.push({
											...v,
											userType: v.bindType
										})
									} else {
										this.formData.bUser.push({
											...v,
											userType: v.bindType
										})
									}
								})
							}

						} else {
							this.$message.error(msg || "获取商品信息失败,请重试");
						}
					})
					.catch(() => {
						this.$message.error("获取商品信息失败,请重试");
					})
					.finally(() => {
						this.dataLoading = false;
						this.reFresh = true;
					});
			},

			//返回
			goBack() {
				if (this.redirect) {
					this.$router.push({
						path: this.redirect,
					});
				} else {
					this.$router.go(-1);
				}
			},
			//表单提交
			onSubmit() {
				var bindList = [];
				if (this.formData.bUser && this.formData.bUser.length > 0) {
					this.formData.bUser.map(v => {
						bindList.push({
							bindType: v.userType,
							name: v.name,
							id: v.id
						})
					})

				}
				if (this.formData.activities && this.formData.activities.length > 0) {
					this.formData.activities.map(v => {
						bindList.push({
							bindType: 6,
							name: v.name,
							id: v.id
						})
					})
				}
				if (this.formData.settlementsVO && this.formData.settlementsVO.length > 0) {
					this.formData.settlementsVO.map(v => {
						bindList.push({
							bindType: 9,
							name: v.name,
							id: v.id
						})
					})
				}
				if (!this.formData.freightType || (this.formData.freightType == 2 && this.formData.freightTemplateId ==
						'')) {
					this.$message.error("请先设置运费！");
					return
				}
				//deliveryType 发货方式  1快递发货 2现场自取 3 快递发货+现场自取  deliveryTimeType 1现货 2预售  deliveryTimeValue 需要几天内发货
				if (this.formData.deliveryTimeType == 1 && !this.formData.deliveryTimeValue && this.formData
					.deliveryType != 2) {
					this.$message.error("请填写发货天数！");
					return
				}
				if (this.formData.deliveryTimeType == 2 && !this.formData.deliveryTimeValue2) {
					this.$message.error("请设置最迟发货日期！");
					return
				}

				if (this.$utils.compareDate(this.formData.startDate, this.formData.deliveryTimeValue2)) {
					return this.$message.error("预售发货时间不能早于销售时间");
				}

				var deliveryTimeValue = this.formData.deliveryTimeType == 1 ? this.formData.deliveryTimeValue : this
					.formData.deliveryTimeValue2

				if (this.formData.categoryId != 9) {
					this.formData.operationalCategory = this.formData.operationalCategory.filter(item => item != 2001 &&
						item != 2002)
				} else {
					this.formData.operationalCategory = this.formData.operationalCategory.filter(item => item != 1380 &&
						item != 1381)
				}
				if (this.onlineStatus == 0) {
					this.formData.onlineTime = ''
				}
				setTimeout(() => {
					this.$refs["formData"].validate((valid) => {
						if (valid) {
							this.btnLoading = true;
							this.$request({
									url: "/shop_good/createOrUpdate",
									method: "POST",
									data: {
										...this.formData,
										serviceTemplateId: this.formData.serviceTemplateId.toString(),
										properties: this.formData.propertyType == 1 ? this.formData
											.properties.filter(v => v.orderIndex == 1) : this.formData
											.properties,
										bindList: bindList,
										freightTemplateId: this.formData.freightType == 2 ? this
											.formData.freightTemplateId : '',
										freightFormat: this.formData.freightType == 1 ? this.formData
											.freightFormat : '',
										operationalCategory: this.formData.operationalCategory.join(
											','),
										deliveryTimeValue: deliveryTimeValue,
										//limitBuyNum:this.formData.categoryId === 9 ?  0 : this.formData.limitBuyNum

									},
								})
								.then((res) => {
									//处理成功回调
									const {
										state,
										msg
									} = res.data;
									if (state && state == 1) {
										if (this.id) {
											this.$confirm('是否返回列表', '操作成功', {
												type: 'success',
												center: true,
												confirmButtonText: '返回列表',
												cancelButtonText: '留在当前页面',
												closeOnClickModal: false
											}).then(() => {
												this.goBack();
											}).catch(() => {
												window.location.reload()
											})
										} else {
											this.$message.success("操作成功");
											this.goBack();
										}

									} else {
										return this.$message.error(msg || "操作失败");
									}
								})
								.catch(() => {
									this.$message.error("操作失败,请重试");
								})
								.finally(() => {
									this.btnLoading = false;
								});
						}
					});
				}, 300);
			},

			validateField(field, callback) {
				const _errorArry = [];
				this.$refs["formData"].validateField(field, (err) => {
					if (err) _errorArry.push(err);
				});
				if (_errorArry.length == 0) {
					callback && callback();
				}
			}
		}
	}
</script>